import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class BranchService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getBranchList(pageNo: number, pageSize: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/branch?pageNo=" + pageNo + "&pageSize=" + pageSize).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveBranch(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/branch", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  updateBranch(id: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/branch/" + id, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getBranchById(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/branch/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getBranchByWholesalerId(id: Number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/branch/wholesaler/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getBranchVolumes(id: Number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/branch/" + id + "/volume").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveBranchVolume(branchId: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/branch/" + branchId + "/volume", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


  getDownloadURL(): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "management/branch/download?token=" + authToken;
  }

  downloadBranches(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "management/branch/download").subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


  deleteBranchVolumes(id: Number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.delete(this.url + "management/branch/" + id + "/volume").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

}